import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../Firebase/Firebase"; // Adjust the path accordingly
import styles from "./AdminLogin.module.scss"; // Import SCSS module

export const AdminLogin = ({
  onLoginSuccess,
}: {
  onLoginSuccess: () => void;
}) => {
  const [email, setEmail] = useState("mcsd1969@gmail.com");
  const [password, setPassword] = useState("Immunotec56");
  const [error, setError] = useState("");

  useEffect(() => {
    const signInAutomatically = async () => {
      try {
        await signInWithEmailAndPassword(auth, email, password);
        onLoginSuccess();
      } catch (err) {
        console.error("Admin login error:", err);
      }
    }

    signInAutomatically();
  }, [password]);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLoginSuccess();
    } catch (err) {
      setError("Login failed. Please try again.");
      console.error("Admin login error:", err);
    }
  };

  return (
    <div className={styles.adminLogin}>
      <h2>Admin Login</h2>
      {error && <p>{error}</p>}
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};
